(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagna-log', {
            parent: 'entity',
            url: '/campagna-log?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagna_log.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-log/campagna-logs.html',
                    controller: 'Campagna_logController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagna_log');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagna-log-detail', {
            parent: 'entity',
            url: '/campagna-log/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagna_log.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagna-log/campagna-log-detail.html',
                    controller: 'Campagna_logDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagna_log');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Campagna_log', function($stateParams, Campagna_log) {
                    return Campagna_log.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagna-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagna-log-detail.edit', {
            parent: 'campagna-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-log/campagna-log-dialog.html',
                    controller: 'Campagna_logDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagna_log', function(Campagna_log) {
                            return Campagna_log.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-log.new', {
            parent: 'campagna-log',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-log/campagna-log-dialog.html',
                    controller: 'Campagna_logDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                causale: null,
                                tipo: null,
                                segno: null,
                                campagnaid: null,
                                importo: null,
                                dtins: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagna-log', null, { reload: 'campagna-log' });
                }, function() {
                    $state.go('campagna-log');
                });
            }]
        })
        .state('campagna-log.edit', {
            parent: 'campagna-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-log/campagna-log-dialog.html',
                    controller: 'Campagna_logDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagna_log', function(Campagna_log) {
                            return Campagna_log.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-log', null, { reload: 'campagna-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagna-log.delete', {
            parent: 'campagna-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagna-log/campagna-log-delete-dialog.html',
                    controller: 'Campagna_logDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Campagna_log', function(Campagna_log) {
                            return Campagna_log.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagna-log', null, { reload: 'campagna-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
